module.exports = __webpack_public_path__ + "img/public/SiteIcons/plusIcon.svg?93bc184d";